export enum AnimationTypes {
  WAVE_LEFT = 'wave-left',
  WAVE_RIGHT = 'wave-right'
}

export interface WaveBgProps {
  animationType?: AnimationTypes;
  animationComplete?: () => void;
  animationStartDirection?: 'left' | 'right'
  className?: string;
}
